import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIPartnerEvents extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  get = async (
    filters?: types.PartnerEventFilters,
  ): Promise<types.PartnerEvent[]> => {
    const params = new URLSearchParams();
    if (filters?.partner_id) params.append("partner_id", filters.partner_id);
    if (filters?.event_type) params.append("event_type", filters.event_type);
    if (filters?.event_category)
      params.append("event_category", filters.event_category);
    if (filters?.resolved !== undefined)
      params.append("resolved", String(filters.resolved));
    if (filters?.limit) params.append("limit", String(filters.limit));
    if (filters?.offset) params.append("offset", String(filters.offset));
    if (filters?.with_relations)
      params.append("with_relations", String(filters.with_relations));

    const res = await this._fetch({
      url: `/partner-events/${params.toString() ? `?${params.toString()}` : ""}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };

  post = async (
    event: types.PartnerEventCreate,
  ): Promise<types.PartnerEvent> => {
    const res = await this._fetch({
      url: `/partner-events/`,
      method: "POST",
      body: event,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };

  getEventId = async (eventId: UUID): Promise<types.PartnerEvent> => {
    const res = await this._fetch({
      url: `/partner-events/${eventId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };

  putEventId = async (
    eventId: UUID,
    event: types.PartnerEventUpdate,
  ): Promise<types.PartnerEvent> => {
    const res = await this._fetch({
      url: `/partner-events/${eventId}`,
      method: "PUT",
      body: event,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };

  deleteEventId = async (eventId: UUID): Promise<types.PartnerEvent> => {
    const res = await this._fetch({
      url: `/partner-events/${eventId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };

  resolveEventId = async (
    eventId: UUID,
    resolveData: types.ResolveEventRequest,
  ): Promise<types.PartnerEvent> => {
    const res = await this._fetch({
      url: `/partner-events/${eventId}/resolve`,
      method: "POST",
      body: resolveData,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json") {
      return res.json();
    }
    throw new Error("Bad content type");
  };
}
